import { render, staticRenderFns } from "./PropertyWindow.vue?vue&type=template&id=07f70624"
import script from "./PropertyWindow.vue?vue&type=script&lang=js"
export * from "./PropertyWindow.vue?vue&type=script&lang=js"
import style0 from "./PropertyWindow.vue?vue&type=style&index=0&id=07f70624&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports